/**
 * @file Re-exports the organization public keys table.
 */

import OrganizationPublicKeysTable from "./OrganizationPublicKeysTable";

export default OrganizationPublicKeysTable;

export { OrganizationPublicKeysTable };
